interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function Modal({ isOpen, onClose, title, subtitle, children, actions }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "var(--space-md)",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          background: "var(--white)",
          borderRadius: "var(--radius-lg)",
          maxWidth: "400px",
          width: "100%",
          padding: "var(--space-xl)",
          boxShadow: "var(--shadow-xl)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {subtitle ? (
          <div style={{ marginBottom: "var(--space-lg)" }}>
            <h3
              style={{
                fontSize: "20px",
                fontWeight: 600,
                color: "var(--ink)",
                margin: 0,
                marginBottom: "var(--space-xs)",
              }}
            >
              {title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "var(--stone)",
                margin: 0,
              }}
            >
              {subtitle}
            </p>
          </div>
        ) : (
          <h2
            style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "var(--ink)",
              margin: 0,
              marginBottom: "var(--space-lg)",
            }}
          >
            {title}
          </h2>
        )}

        {children}

        {actions && (
          <div
            style={{
              display: "flex",
              gap: "var(--space-sm)",
              marginTop: "var(--space-lg)",
            }}
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
